import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import type { TimeLimitedDiscountDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/common';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const timeLimitedDiscountsSelector = selector<TimeLimitedDiscountDTO[]>({
    key: 'timeLimitedDiscounts',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        if (!isLoggedOn) {
            return [];
        }
        return await OnlineSales.getTimeLimitedDiscounts(jobNumber, sessionId);
    }
});
